// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"5996de86","521":"9d68d83d","526":"1a8a4006","582":"656c9054","764":"8353c9d9","787":"c94f9fa5","815":"3ab917c5","819":"1a3ba40f","972":"dfc3f0d1"}[chunkId] + ".chunk.js";
};